import type { ReceiptTemplate } from '../schema';

export const amazonTemplate: ReceiptTemplate = {
  id: 'amazon',
  name: 'Amazon Receipt',
  brand: 'AMAZON',
  description: 'Online retail receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'amazon-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/amazon.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [
          'www.amazon.com',
          'Order Receipt',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'amazon-order',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Order #: 112-4857291-8472910\nOrder Date: January 4, 2026\nShip To: Mike Wazowski',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'amazon-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'amazon-item-1', name: 'Wireless Earbuds Pro', quantity: '1', price: '49.99'},
          { id: 'amazon-item-2', name: 'USB-C Charging Cable', quantity: '2', price: '12.99'},
          { id: 'amazon-item-3', name: 'Phone Case Clear', quantity: '1', price: '15.99'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'amazon-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        labelAlignment: 'left',
        lines: [
          { id: 'amazon-subtotal', label: 'Items Subtotal', value: '91.96', isBold: false, isLarge: false },
          { id: 'amazon-shipping', label: 'Shipping', value: '0.00', isBold: false, isLarge: false },
          { id: 'amazon-tax', label: 'Tax', value: '8.16', isBold: false, isLarge: false },
          { id: 'amazon-total', label: 'Order Total', value: '100.12', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 15,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'amazon-payment',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Payment Method:\nVisa ending in 4144\nBilling Address: 1200 Dark Avenue\nMonsterville, CA 94608',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'amazon-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '1124857291847',
        showValue: true,
        width: 1.5,
        height: 40,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'amazon-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Returns accepted within 30 days.\nVisit amazon.com/returns',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

